export enum ParkingsFilter {
  ALL = 'ALL',
  WELL_RATED = 'WELL_RATED',
}
